import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { AnalyticsEventActions, AnalyticsEventSource, GenericErrorPage, logException } from '@atlassian/ptc-common';
// eslint-disable-next-line @repo/internal/react/no-class-components
export default class ErrorBoundary extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      hasError: false
    });
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      analytics,
      appName
    } = this.props;
    logException(error, 'Caught error in ErrorBoundaryApp', {
      info: errorInfo,
      tags: {
        severity: 'high'
      }
    });
    analytics.pushOperationalEvent({
      source: AnalyticsEventSource.CLIENT_METRICS,
      actionSubject: 'errorBoundary',
      action: AnalyticsEventActions.TRIGGERED,
      attributes: {
        product: appName,
        boundary: 'app',
        error: error.toString()
      },
      tags: ['error', 'error-boundary']
    });
  }
  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return /*#__PURE__*/React.createElement(GenericErrorPage, {
      hasSupportLink: true
    });
  }
}